import { FunctionComponent } from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import * as styles from './ShipmentTracker.module.scss';

export type StatusType = {
  description: string;
  progressBarSubtext: string;
  statusName: string;
  percentage: number;
};
export type ShipmentTrackerProps = {
  status: StatusType;
};

export const ShipmentTracker: FunctionComponent<ShipmentTrackerProps> = ({ status }) => (
  <div className={styles.container}>
    <h1 className={styles.shipmentStatus}>{status.description}</h1>
    <div className={styles.shipmentProgressContainer}>
      <div className={styles.shipmentProgressBarBackground}>
        <div
          className={classNames(styles.shipmentProgressBar, styles[status.statusName])}
          style={{ width: `${status.percentage}%` }}
          data-testid="progress-bar"
        />
      </div>
      {status.percentage === 100 && (
        <div className={styles.shipmentDeliveredCheckmark}>
          <FontAwesomeIcon icon={faCheck} />
        </div>
      )}
    </div>
    <div className={styles.shipmentEstimatedDate}>{status.progressBarSubtext}</div>
  </div>
);
